"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDevConsole = useDevConsole;
var _underscore = _interopRequireDefault(require("underscore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import React from 'react';
const STYLE_PROPS = {
  color: 'color',
  backgroundColor: 'background-color',
  border: 'border',
  font: 'font',
  padding: 'padding',
  fontFamily: 'font-family'
};
const getStyleStr = options => {
  let styleStr = '';
  if (!_underscore.default.isObject(options)) return styleStr;
  Object.keys(STYLE_PROPS).forEach(styleKey => {
    if (options[styleKey]) styleStr += "".concat([STYLE_PROPS[styleKey]], ": ").concat(options[styleKey], "; ");
  });
  return styleStr;
};
const noOps = {
  dir: () => {},
  log: () => {},
  warn: () => {},
  clear: () => {},
  error: () => {},
  table: () => {},
  print: () => {},
  assert: () => {},
  logStep: () => {},
  logNote: () => {},
  logCounts: () => {},
  logError: () => {},
  logDanger: () => {},
  logWarning: () => {},
  logSuccess: () => {},
  logSecurity: () => {},
  logWithIcon: () => {},
  logHttpResponse: () => {},
  logSecurityWarning: () => {}
};
const dir = console.dir;
const log = console.log;
const warn = console.warn;
const clear = console.clear;
const table = console.table;
const error = console.error;
const assert = console.assert;
const print = function (msg) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const styleStr = getStyleStr(options);
  let args = [msg];
  if (!!styleStr) args = ["%c".concat(msg), styleStr];
  for (var _len = arguments.length, otherArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    otherArgs[_key - 2] = arguments[_key];
  }
  if (otherArgs.length) args.push(...otherArgs);
  return console.log(...args);
};
const logSuccess = function (msg) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return print("".concat(EMOJIS.success, " ").concat(msg), {
    color: 'royalblue'
  }, ...args);
};
const logSecurity = function (msg) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  return print("".concat(EMOJIS.shield, " ").concat(msg), {
    color: 'lightslategray'
  }, ...args);
};
const logError = function (msg) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  return print("".concat(EMOJIS.nope, " ").concat(msg), {
    color: 'firebrick'
  }, ...args);
};
const logWarning = function (msg) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }
  return print("".concat(EMOJIS.warning, " ").concat(msg), {
    color: 'orange'
  }, ...args);
};
const logStep = function (msg) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }
  return print("".concat(EMOJIS.turtle, " ~~~  ").concat(msg, " ~~~ ").concat(EMOJIS.turtle), {
    fontFamily: 'monospace',
    color: '#808080'
  }, ...args);
};
const logWithIcon = function (iconName, msg) {
  const icon = EMOJIS[iconName] || '';
  for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
    args[_key7 - 2] = arguments[_key7];
  }
  return print("".concat(icon, " ").concat(msg), {}, ...args);
};
const logHttpResponse = _ref => {
  let {
    msg = '',
    statusCode = 0
  } = _ref;
  let _msg = msg;
  if (!statusCode || isNaN(statusCode)) console.warn('logHttpResponse should receive both a message and status code parameter');
  if (typeof msg !== 'string') {
    console.warn('logHttpResponse should receive a string as a message parameter, received: ', msg);
    _msg = JSON.stringify(msg);
  }
  const msgAndStatusCode = "".concat(_msg, " (status ").concat(statusCode, ")");
  if (statusCode >= 400) {
    return logError(msgAndStatusCode);
  }
  if (statusCode >= 300) {
    return logWarning(msgAndStatusCode);
  }
  if (statusCode >= 200) {
    return logSuccess(msgAndStatusCode);
  }
  return log(msgAndStatusCode);
};
const logNote = function () {
  for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }
  return logWithIcon('note', ...args);
};
const logCounts = function () {
  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }
  return logWithIcon('stats', ...args);
};
const logDanger = function () {
  for (var _len0 = arguments.length, args = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
    args[_key0] = arguments[_key0];
  }
  return warn(EMOJIS.exclamation, ...args);
};
const logSecurityWarning = function () {
  for (var _len1 = arguments.length, args = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
    args[_key1] = arguments[_key1];
  }
  return warn(EMOJIS.shield, ...args);
};
function useDevConsole() {
  if (process.env.NODE_ENV !== 'development') {
    return _objectSpread({}, noOps);
  }
  return {
    dir,
    log,
    warn,
    error,
    clear,
    print,
    table,
    assert,
    logStep,
    logNote,
    logCounts,
    logError,
    logDanger,
    logWarning,
    logSuccess,
    logSecurity,
    logWithIcon,
    logHttpResponse,
    logSecurityWarning
  };
}
;
const EMOJIS = {
  success: '✅',
  nope: '❌',
  warning: '🧐',
  turtle: '🐢',
  frog: '🐸',
  SOS: '🆘',
  siren: '🚨',
  airplane: '✈️',
  train: '🚂',
  ship: '🛳️',
  car: '🚗',
  bike: '🚲',
  bus: '🚌',
  truck: '🚚',
  connected: '🔌',
  info: 'ℹ️',
  question: '❓',
  exclamation: '❗️',
  exclaim: '❗️❗️',
  star: '⭐',
  rocket: '🚀',
  wifi: '📡',
  shield: '🛡',
  disk: '💾',
  folder: '📁',
  folderOpen: '📂',
  globe: '🌍',
  file: '📄',
  link: '🔗',
  thumbsUp: '👍',
  thumbsDown: '👎',
  surf: '🏄',
  ski: '🎿',
  snowboard: '🏂',
  snowman: '⛄',
  bomb: '💣',
  fire: '🔥',
  gift: '🎁',
  trophy: '🏆',
  medal: '🏅',
  heartBroken: '💔',
  cactus: '🌵',
  arrowUp: '⬆️',
  arrowDown: '⬇️',
  arrowLeft: '⬅️',
  arrowRight: '➡️',
  pencil: '✏️',
  pen: '🖊️',
  forward: '⏩',
  backward: '⏪',
  play: '▶️',
  pause: '⏸',
  stop: '⏹',
  key: '🔑',
  lock: '🔒',
  lockOpen: '🔓',
  turnKey: '🗝',
  canvas: '🖼️',
  clipboard: '📋',
  list: '📝',
  worker: '👷',
  paint: '🎨',
  geometry: '📐',
  tool: '🔧',
  hammer: '🔨',
  dot: '•',
  square: '□',
  triangle: '△',
  circle: '◯',
  duplicate: '📑',
  note: '📝',
  books: '📚',
  fountainPen: '🖋️',
  redCrayon: '🖍️',
  iceCube: '🧊',
  climber: '🧗',
  wizard: '🧙',
  abacus: '🧮',
  zombie: '🧟',
  timer: '🧭',
  puzzle: '🧩',
  genie: '🧞',
  palmTree: '🌴',
  tag: '🏷',
  date: '📅',
  number: '🔢',
  stats: '📊'
};
const phases = ['🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘'];